import script from "./HighlightText.vue?vue&type=script&setup=true&lang=js"
export * from "./HighlightText.vue?vue&type=script&setup=true&lang=js"

import "./HighlightText.vue?vue&type=style&index=0&id=74497fef&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74497fef"]])

export default __exports__